var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AlertController } from 'ionic-angular';
import { Logger } from '@apto/ng2-apto-map';
import { ExportFile, ExportFileStatus, ExportService } from '@apto/shared/services';
import './export-file.scss';
var ExportFileComponent = /** @class */ /*@__PURE__*/ (function () {
    function ExportFileComponent(exportService, alertController, logger) {
        this.exportService = exportService;
        this.alertController = alertController;
        this.logger = logger;
        this.successStatus = ExportFileStatus.SUCCESS;
        this.failStatus = ExportFileStatus.FAILED;
        this.pendingStatus = ExportFileStatus.PENDING;
    }
    ExportFileComponent.prototype.downloadFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link, errorMessage_1, alert_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.exportService.downloadLink(this.file)];
                    case 1:
                        link = _a.sent();
                        this.download(link);
                        return [3 /*break*/, 3];
                    case 2:
                        errorMessage_1 = _a.sent();
                        alert_1 = this.alertController.create({
                            cssClass: 'export-file--download-error',
                            title: 'Download Error',
                            message: 'There was an error attempting to download the file. Please try again.',
                            buttons: [
                                {
                                    text: 'Ok',
                                    role: 'ok',
                                    handler: function (data) {
                                        alert_1.dismiss();
                                    }
                                }
                            ]
                        });
                        alert_1.present();
                        this.logger.error(errorMessage_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ExportFileComponent.prototype.download = function (link) {
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            //making a missclick for a file dropdown item  making closed
            document.elementFromPoint(0, 0).click();
            window.open(link);
        }
        else {
            window.location.assign(link);
        }
    };
    return ExportFileComponent;
}());
export { ExportFileComponent };
